import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "appHeader" }
const _hoisted_2 = { class: "container d-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "brandMark" }
const _hoisted_4 = {
  key: 0,
  class: "userName"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_buildings = _resolveComponent("icon-buildings")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/home",
        class: "brand"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_icon_buildings)
          ]),
          _cache[0] || (_cache[0] = _createTextVNode(" Brochure & Magazine "))
        ]),
        _: 1
      }),
      (_ctx.userName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.userName), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}